import { CompanyRole } from '@dispatch/shared/types';

export const useGetCompanyRoleOptions = (roles: CompanyRole[]) => {
  const companyRoleOptions = roles?.map((role: CompanyRole) => {
    return { value: role.integrationGUID, title: role?.name || '' };
  });

  return {
    companyRoles: companyRoleOptions,
  };
};
